import {IAlertModal, IAdmin} from "@data";
import {atom} from "recoil";
import stateKeys from "./stateKeys";
import {ScreenId} from "@assets";

const states = {
  alertState: atom<IAlertModal>({
    key: stateKeys.alertModalKey,
    default: {},
  }),
  adminDataState: atom<IAdmin | undefined>({
    key: stateKeys.adminDataKey,
    default: undefined,
  }),
  loadingState: atom<boolean>({
    key: stateKeys.loadingKey,
    default: false,
  }),
  pathState: atom<ScreenId>({
    key: stateKeys.pathKey,
    default: undefined,
  }),
};

export default states;
